/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Credential_Invalid_Toast_DescInputs */

const vi_einvoice_credential_invalid_toast_desc = /** @type {(inputs: Einvoice_Credential_Invalid_Toast_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiểm tra lại kết nối tài khoản MISA rồi thử lại.`)
};

/**

* @param {Einvoice_Credential_Invalid_Toast_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_invalid_toast_desc = /** @type {((inputs?: Einvoice_Credential_Invalid_Toast_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_Invalid_Toast_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_invalid_toast_desc(inputs)
});